import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line"
import { Input } from "../../../../../../components/inputs/input/input"
import { SHIPPING_LINE_TYPE } from "../../../../constants";
import ResolutionStore from "../../../../stores/resolution-store";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import { observer } from "mobx-react";

type ShippingTitleFieldLineProps = {
    resolution: ResolutionStore;
	validationGroup: IValidationGroup;
}

export const ShippingTitleFieldLine = observer(({ resolution, validationGroup }: ShippingTitleFieldLineProps) => {
    const title = resolution?.shippingSettingsStore?.shippingLine === SHIPPING_LINE_TYPE.CREATE_CUSTOM_FREE_SHIPPING ? 'Create new free shipping option' : 'Enter the exact shipping method name';
    const note = resolution?.shippingSettingsStore?.shippingLine === SHIPPING_LINE_TYPE.CREATE_CUSTOM_FREE_SHIPPING ? 'This name will be used to create a new free shipping option' : 'Must match an existing shipping method name exactly';

    return (
        <FormFieldLine
            label={title}
            note={note}
        >
            <Input
                value={resolution.shippingSettingsStore?.shippingLineTitle}
                onChange={(v) => resolution.shippingSettingsStore?.setShippingLineTitle(v as string)}
				placeholder={`e.g.: Free shipping for exchanges"`}
				required
				validationGroup={validationGroup}
            />
        </FormFieldLine>
    )
});